import styled from 'styled-components';
import { Icon } from '@material-ui/core';

export const FieldsArea = styled.div`
  display: flex;
  column-gap: 16px;
`;

export const FieldContainer = styled.div`
  flex-grow: 1;
`;

export const LabelIcon = styled(Icon)`
  vertical-align: middle;
  margin-top: -3px;
  font-size: 1.3rem;
`;
